{
  "id": "rusticFrame",
  "name": "Rustic Frame",
  "builds": "product",
  "category": "rustic",
  "note": "Reclaimed wood cut to a tolerance it has never been held to.",
  "skill": "rusticProjects",
  "duration": 25,
  "offeredBy": "hammer",
  "fastener": "nails",
  "value": 12,
  "widthIn": 12,
  "heightIn": 24,
  "slots": [
    {
      "id": "rail-0",
      "role": "rail",
      "part": {
        "widthIn": 2,
        "lengthIn": 24,
        "thicknessQ": 4,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -45
          },
          "right": {
            "kind": "mitered",
            "angle": 45
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "pallet",
        "surface": "sanded"
      },
      "xIn": 1,
      "yIn": 12,
      "angleDeg": 0,
      "zIn": 0
    },
    {
      "id": "rail-1",
      "role": "rail",
      "part": {
        "widthIn": 2,
        "lengthIn": 24,
        "thicknessQ": 4,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -45
          },
          "right": {
            "kind": "mitered",
            "angle": 45
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "pallet",
        "surface": "sanded"
      },
      "xIn": 11,
      "yIn": 12,
      "angleDeg": 180,
      "zIn": 0
    },
    {
      "id": "rail-2",
      "role": "rail",
      "part": {
        "widthIn": 2,
        "lengthIn": 12,
        "thicknessQ": 4,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -45
          },
          "right": {
            "kind": "mitered",
            "angle": 45
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "pallet",
        "surface": "sanded"
      },
      "xIn": 6,
      "yIn": 1,
      "angleDeg": 90,
      "zIn": 0
    },
    {
      "id": "rail-3",
      "role": "rail",
      "part": {
        "widthIn": 2,
        "lengthIn": 12,
        "thicknessQ": 4,
        "ends": {
          "left": {
            "kind": "mitered",
            "angle": -45
          },
          "right": {
            "kind": "mitered",
            "angle": 45
          }
        }
      },
      "stock": {
        "type": "board",
        "species": "pallet",
        "surface": "sanded"
      },
      "xIn": 6,
      "yIn": 23,
      "angleDeg": 270,
      "zIn": 0
    }
  ],
  "fasteners": [
    {
      "xIn": 1,
      "yIn": 1
    },
    {
      "xIn": 1,
      "yIn": 23
    },
    {
      "xIn": 11,
      "yIn": 1
    },
    {
      "xIn": 11,
      "yIn": 23
    }
  ]
}
